import { create } from "zustand";

export interface UserInfo {
  id: string;
  name: string;
  account: string;
  avatar: string | null;
  is_system_admin: boolean;
  created_at: string;
  updated_at: string;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: UserInfo | null;
  setTokens: (access: string, refresh: string) => void;
  setUser: (user: UserInfo) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  accessToken: localStorage.getItem("agents-web:access_token"),
  refreshToken: localStorage.getItem("agents-web:refresh_token"),
  user: JSON.parse(localStorage.getItem("agents-web:user") || "null"),

  setTokens: (access, refresh) => {
    localStorage.setItem("agents-web:access_token", access);
    localStorage.setItem("agents-web:refresh_token", refresh);
    set({ accessToken: access, refreshToken: refresh });
  },

  setUser: (user) => {
    localStorage.setItem("agents-web:user", JSON.stringify(user));
    set({ user });
  },

  logout: () => {
    localStorage.removeItem("agents-web:access_token");
    localStorage.removeItem("agents-web:refresh_token");
    localStorage.removeItem("agents-web:user");
    set({ accessToken: null, refreshToken: null, user: null });
  },

  isAuthenticated: () => !!get().accessToken,
}));
